import { TAppNameEnum, TError, TOnlineUsersResponseSchema } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { WHO_IS_ONLINE_ENTITY } from './entity';

type TOptions = {
  enabled?: boolean;
  refetchInterval?: number;
};

export const WHO_IS_ONLINE_QUERY_KEYS = {
  all: ['who-is-online'] as const,
  heartbeat: (appName: TAppNameEnum) => [...WHO_IS_ONLINE_QUERY_KEYS.all, 'heartbeat', appName] as const,
  allUsers: () => [...WHO_IS_ONLINE_QUERY_KEYS.all, 'all-users'] as const,
  publicUsers: () => [...WHO_IS_ONLINE_QUERY_KEYS.all, 'public-users'] as const,
};

export const useGetAllOnlineUsersQuery = (options: TOptions = {}) => {
  const { enabled, refetchInterval } = options;

  return useQuery<TOnlineUsersResponseSchema, TError>({
    queryKey: WHO_IS_ONLINE_QUERY_KEYS.allUsers(),
    queryFn: async () => {
      const res = await axios.get<TOnlineUsersResponseSchema>(`/${WHO_IS_ONLINE_ENTITY}/users`);
      return res.data;
    },
    enabled: enabled ?? true,
    refetchInterval,
  });
};
